import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DataStoreService } from './utils/data_store/data-store.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  // Use modern constructor-less dependency injections
  private readonly router = inject(Router);
  private readonly store = inject(DataStoreService);

  readonly title = 'upg-rewards-admin-r2';

  ngOnInit(): void {
    this.evaluateInitialAccessRedirect();
  }

  /**
   * Assesses local security tokens on cold boot to route users accurately
   */
  private evaluateInitialAccessRedirect(): void {
    const isAuthorized = !!this.store.getAuth();

    if (!isAuthorized) {
      // Direct unauthorized visitors back to security checkpoint login views
      this.router.navigate(['/login']);
    } else {
      // Route verified administrative credentials straight to layout panels
      this.router.navigate(['/nav']);
    }
  }
}
